export const passwordMinLength = 6;
export const appName = 'Visual Math Karate';
